import * as React from 'react';

import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';

import imgSrc from './assets/img.svg';
import * as styles from './styles.css';

interface IReferralHeroProps {
  stickyRef?: React.Ref<HTMLDivElement>;
  onClick: () => void;
}

export const ReferralHero: React.FC<IReferralHeroProps> = ({ stickyRef, onClick }) => {
  return (
    <div className={styles['container']} ref={stickyRef}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading1 color="text-inverted-default">
            Вам посоветовали <br /> профи от Циана
          </UIHeading1>
          <UIText1 color="text-inverted-default">Поможем купить или продать недвижимость выгодно и спокойно</UIText1>

          <Button theme="fill_white_primary" size="L" onClick={onClick}>
            Получить консультацию
          </Button>
        </div>

        <div className={styles['img']}>
          <img src={imgSrc} alt="Вам посоветовали Сделку" />
        </div>
      </div>
    </div>
  );
};
